<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a_RM"><a id="page_vii">Contents</a></h2><a id="page_vii">
</a><h2 class="toc-fronta"><a id="page_vii"></a><a href="#/xhtml/07_Introduction"><span class="small">INTRODUCTION</span></a></h2>
<h2 class="toc-chap"><a href="#/xhtml/08_Chapter_01"><span class="toc-chap_float">1</span> “Nothing but Divisions Among Our People”</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter_02" title="Link target outside of Sample"><span class="toc-chap_float">2</span> “Rich Man’s War”</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter_03" title="Link target outside of Sample"><span class="toc-chap_float">3</span> “Fighting Each Other Harder Than We Ever Fought the Enemy”</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter_04" title="Link target outside of Sample"><span class="toc-chap_float">4</span> “Yes, We All Shall Be Free”</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter_05" title="Link target outside of Sample"><span class="toc-chap_float">5</span> “Now the Wolf Has Come”</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter_06" title="Link target outside of Sample"><span class="toc-chap_float">6</span> “Defeated … by the People at Home”</span></h2>
<h2 class="toc-back"><span href="#/xhtml/18_Notes" title="Link target outside of Sample"><span class="small">NOTES</span></span></h2>
<h2 class="toc-backa"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample"><span class="small">BIBLIOGRAPHY</span></span></h2>
<h2 class="toc-backa"><span href="#/xhtml/21_Index" title="Link target outside of Sample"><span class="small">INDEX</span></span><a id="page_viii"></a></h2><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?25985f2d